/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type UserGuide,
    UserGuideFromJSON,
    UserGuideToJSON,
} from '../models/UserGuide';

/**
 * 
 */
export class UserGuideApi extends runtime.BaseAPI {

    /**
     * Creates request options for userGuideRetrieve without sending the request
     */
    async userGuideRetrieveRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/user_guide/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get the latest user guide file URL
     * Retrieve user guide
     */
    async userGuideRetrieveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserGuide>> {
        const requestOptions = await this.userGuideRetrieveRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserGuideFromJSON(jsonValue));
    }

    /**
     * Get the latest user guide file URL
     * Retrieve user guide
     */
    async userGuideRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserGuide> {
        const response = await this.userGuideRetrieveRaw(initOverrides);
        return await response.value();
    }

}
